const mrpDistributionHeader = [
  {
    group: 'Centro',
    columns: [
      {
        name: 'Código',
        id: 'centro-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'centro-nome',
        show: false
      }
    ]
  },
  {
    group: 'Centro de Distribuição',
    columns: [
      {
        name: 'Código',
        id: 'centro-distribuicao-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'centro-distribuicao-nome',
        show: false
      }
    ]
  },
  {
    group: 'Produto',
    columns: [
      {
        name: 'Código',
        id: 'produto-id',
        show: true
      },
      {
        name: 'Material',
        id: 'produto-material',
        show: true
      },
      // {
      //   name: 'Mundo',
      //   id: 'produto-mundo',
      //   show: true
      // },
      {
        name: 'Categoria Compacta',
        id: 'produto-categoria-compacta',
        show: true
      },
      {
        name: 'Categoria',
        id: 'produto-categoria',
        show: false
      },
      {
        name: 'Sub Categoria',
        id: 'produto-sub-categoria',
        show: true
      },
      {
        name: 'Curva',
        id: 'produto-curva-abc',
        show: true
      },
      // {
      //   name: 'Curva ABC Empresa',
      //   id: 'produto-curva-abc-empresa',
      //   show: true
      // },
      {
        name: 'Status',
        id: 'produto-status',
        show: true
      },
      // {
      //   name: 'Gerente Produto Id',
      //   id: 'gerente-produto-id',
      //   show: true
      // },
      {
        name: 'Gerente Produto',
        id: 'gerente-produto-desc',
        show: true
      },
      {
        name: 'Lote Múltiplo',
        id: 'produto-lote',
        show: false
      },
      {
        name: 'Grupo de Separação',
        id: 'produto-grupo-separacao',
        show: false
      }
    ]
  },
  {
    group: 'Fornecedor',
    columns: [
      {
        name: 'Código',
        id: 'fornecedor-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'fornecedor-nome',
        show: true
      }
    ]
  },
  {
    group: 'Ruptura',
    columns: [
      {
        name: '0 Dias',
        id: 'ruptura-zero-dias',
        show: true
      },
      {
        name: '10 Dias',
        id: 'ruptura-dez-dias',
        show: true
      }
    ]
  },
  {
    group: 'Recomendação',
    columns: [
      {
        name: 'Quantidade',
        id: 'recomendacao-quantidade',
        show: true,
        isNumeric: true
      },
      {
        name: 'Peso',
        id: 'recomendacao-peso',
        show: false,
        isNumeric: true
      },
      {
        name: 'Volume',
        id: 'recomendacao-volume',
        show: false,
        isNumeric: true
      },
      {
        name: 'Custo (R$)',
        id: 'recomendacao-custo',
        show: true,
        isNumeric: true
      },
      {
        name: 'Tipo de Alerta',
        id: 'recomendacao-tipo-alerta',
        show: true,
        isNumeric: true
      },
      {
        name: 'Nível de Serviço %',
        id: 'recomendacao-nivel-servico',
        show: false,
        isNumeric: true
      }
    ]
  },
  {
    group: 'Compra',
    columns: [
      {
        name: 'Peso',
        id: 'compra-peso',
        show: false,
        isNumeric: true
      },
      {
        name: 'Volume',
        id: 'compra-volume',
        show: false,
        isNumeric: true
      },
      {
        name: 'Desejada',
        id: 'compra-desejada',
        show: true,
        isNumeric: true
      },
      {
        name: 'Custo (R$)',
        id: 'compra-custo',
        show: true,
        isNumeric: true
      },
      {
        name: 'Nível de Serviço %',
        id: 'compra-nivel-servico',
        show: false,
        isNumeric: true
      }
    ]
  },
  {
    group: 'Carga Formatada',
    columns: [
      {
        name: 'Quantidade',
        id: 'carga-quantidade',
        show: true,
        isNumeric: true
      },
      {
        name: 'Peso',
        id: 'carga-peso',
        show: true,
        isNumeric: true
      }
    ]
  },
  {
    group: 'Estoque',
    columns: [
      {
        name: 'MAX',
        id: 'estoque-max',
        show: false,
        isNumeric: true
      },
      {
        name: 'CD',
        id: 'estoque-cd',
        show: false,
        isNumeric: true
      },
      {
        name: 'Reservado',
        id: 'estoque-reservado',
        show: false,
        isNumeric: true
      },
      {
        name: 'Disponível',
        id: 'estoque-disponivel',
        show: true,
        isNumeric: true
      },
      {
        name: 'Trânsito Total',
        id: 'estoque-transito',
        show: false,
        isNumeric: true
      },
      {
        name: 'Dep. 16',
        id: 'estoque-dep',
        show: false,
        isNumeric: true
      },
      {
        name: 'Outros',
        id: 'estoque-outros',
        show: false,
        isNumeric: true
      },
      {
        name: 'Venda Média Diária',
        id: 'estoque-venda-diaria',
        show: true,
        isNumeric: true
      },
      {
        name: 'Venda Média Mensal',
        id: 'estoque-venda-mensal',
        show: false,
        isNumeric: true
      },
      {
        name: 'Qtde Ponto de Pedido',
        id: 'estoque-qtde-ponto-pedido',
        show: true,
        isNumeric: true
      }
    ]
  },
  {
    group: 'Cobertura (Dias)',
    columns: [
      {
        name: 'Alvo',
        id: 'cobertura-alvo',
        show: true,
        isNumeric: true
      },
      {
        name: 'Atual',
        id: 'cobertura-atual',
        show: true,
        isNumeric: true
      },
      {
        name: 'Trânsito',
        id: 'cobertura-transito',
        show: false,
        isNumeric: true
      },
      {
        name: 'Ponto de Pedido',
        id: 'cobertura-ponto-pedido',
        show: true,
        isNumeric: true
      },
      {
        name: 'Recomendação',
        id: 'cobertura-sugestao',
        show: false,
        isNumeric: true
      },
      {
        name: 'Desejada',
        id: 'cobertura-desejada',
        show: false,
        isNumeric: true
      },
      {
        name: 'Formatada',
        id: 'cobertura-formatada',
        show: true,
        isNumeric: true
      },
      {
        name: 'Diferença',
        id: 'cobertura-diferenca',
        show: false,
        isNumeric: true
      }
    ]
  },
  {
    group: 'VMM',
    columns: [
      {
        name: 'Primeira Entrada',
        id: 'vmm-primeira-entrada',
        show: false
      },
      {
        name: 'Janela Efetiva',
        id: 'vmm-janela-efetiva',
        show: false,
        isNumeric: true
      }
    ]
  }
]

export default mrpDistributionHeader
